import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { RichTextField } from '../RichTextField/RichTextField'
import { AdvantagesSectionProps } from './types'

export function AdvantagesSection({ title, subtitle, body }: AdvantagesSectionProps) {
  return (
    <section
      className="relative px-24 text-center max-w-3xl laptop:max-w-4xl mx-auto flex flex-col py-24 netbook:px-90 netbook:py-64"
      id={kebabCase(title)}
    >
      <p className="font-poppins text-left tablet:text-center text-primary-500 uppercase font-bold text-preheader mb-24 tablet:mb-16 tracking-widest">
        {title}
      </p>
      <h2 className="font-poppins text-left tablet:text-center font-bold text-text-dark-900 text-headingL-mobile mb-24 tablet:mb-16 netbook:text-headingM">
        {subtitle}
      </h2>
      <div className="text-bodyL text-text-dark-900 text-left tablet:text-center mx-auto tablet:max-w-44">
        {typeof body === 'string' ? body : <RichTextField data={body} />}
      </div>
    </section>
  )
}
